'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _headerBarStyles = require('../header-bar-styles');

var _headerBarStyles2 = _interopRequireDefault(_headerBarStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResultsList = function (_Component) {
    _inherits(SearchResultsList, _Component);

    function SearchResultsList() {
        _classCallCheck(this, SearchResultsList);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(SearchResultsList).apply(this, arguments));
    }

    _createClass(SearchResultsList, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { style: _headerBarStyles2.default.searchResultList },
                this.props.children
            );
        }
    }]);

    return SearchResultsList;
}(_react.Component);

exports.default = SearchResultsList;

SearchResultsList.propTypes = {
    children: _react.PropTypes.array.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/app-header/search/SearchResultsList.js
// module id = 397
// module chunks = 0